import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
export const getTransactionById = async (transactionId: string) => {
  const url = `${ENDPOINTS.TRANSACTION}/${transactionId}`
  const { data } = await api.get<TransactionDetailsResponseType>(url)
  return data
}
const useTransactionById = (transactionId: string) =>
  useQuery({
    queryKey: [ENDPOINTS.TRANSACTION, transactionId],
    queryFn: () => getTransactionById(transactionId),
  })
export default useTransactionById
